// extracted by mini-css-extract-plugin
export default {"link":"StoryCard_link__olUJ1","container":"StoryCard_container__nj-Ln","inner-container":"StoryCard_inner-container__24vDp"};